import { Compass, Cpu, HandCoins, KeyRound } from "lucide-react";

export const ACTIVITIES = [
    {
        id: "land-development",
        n: "01",
        icon: Compass,
        title: "Land Development & Investment",
        short: "We find promising land, take it through planning and licensing, and sell the approved project to an established developer.",
        tagline: "Our core business.",
        what: "We identify raw or underdeveloped land, design a concept, manage the planning and licensing process, and bring the approved development opportunity to market.",
        steps: ["Identify promising land", "Analyse feasibility and potential", "Acquire or secure the plot", "Develop the concept and planning strategy", "Obtain licences and approvals", "Sell the approved project to a developer"],
        who: "Landowners with plots that have potential, developers looking for approved projects, and investment partners who want to participate alongside us.",
        value: "Land that was overlooked becomes a licensed, de-risked opportunity a developer can build on. We focus on Greater Lisbon: Cascais, Sintra, Oeiras and Lisbon.",
        cta: { label: "Explore our projects", to: "/projects" },
    },
    {
        id: "transactions",
        n: "02",
        icon: KeyRound,
        title: "Land Transactions",
        short: "We work with anyone looking for land in Portugal — from big international brands to private individuals.",
        tagline: "Looking for land in Portugal? Let's talk.",
        what: "We work with anyone looking for land in Portugal — from big international brands to private individuals. We help them identify and acquire the right plot, anywhere in the country: from commercial sites and land for data centers, all the way to trophy assets.",
        steps: ["Private individuals seeking residential plots", "Developers seeking development land", "Family offices seeking strategic opportunities", "International companies seeking commercial plots", "Investors in hospitality, logistics and other uses"],
        stepsLabel: "Who we help",
        who: "Anyone — from international brands and family offices to developers and private buyers.",
        value: "Local knowledge, a trusted network and someone who has walked the land before you do.",
        cta: { label: "I'm looking for land", to: "/contact?type=find-land" },
        partner: "taylor",
    },
    {
        id: "financing",
        n: "03",
        icon: HandCoins,
        title: "Verde Capital",
        short: "Good projects need the right capital at the right time. Short-term, senior-secured financing for experienced developers.",
        tagline: "Good projects need the right capital at the right time.",
        what: "Verde Capital is a separate business that operates between Amsterdam and Lisbon. Through Verde Capital, we help experienced developers access short-term, senior-secured financing to move projects forward.",
        who: "Experienced property developers with projects that may not yet qualify for conventional bank construction finance.",
        value: "Capital at the stage where projects most often stall.",
        cta: { label: "Explore Verde Capital", external: "verde_capital_url" },
    },
    {
        id: "land-intelligence",
        n: "04",
        icon: Cpu,
        title: "Land Intelligence",
        short: "We use technology to make smarter development decisions — and bring our AI framework to developers who want to do the same.",
        tagline: "Smarter development decisions, powered by AI.",
        what: "We built our own AI framework to find, study and qualify land — screening the market daily, researching planning and constraints, and preparing every deal for a human decision. Now we help developers implement the same framework across their own business.",
        who: "Developers and real estate businesses that want to find better land, assess it faster and make decisions on evidence, not instinct.",
        value: "A proven, human-led AI framework built and used on our own projects — implemented around your team, your markets and your process.",
        cta: { label: "Discover Land Intelligence", to: "/land-intelligence" },
    },
];
